import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'errors-messages-inline',
    templateUrl: './errors-messages-inline.component.html',
    styleUrls: ['./errors-messages-inline.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ErrorsMessagesInlineComponent {}
